import { isEqual } from 'lodash';
import {
  EMPTY_GREEKS,
  Greeks,
  GREEKS_PRECISION,
} from '#/unified-rfqs/entities/greeks';
import {
  formatMark,
  parseGreekValue,
  unformatDecimal,
} from '@paradigm/utils/formatDecimal';
import { State } from '../store';
import calculateGreeks from '../calculateGreeks';

export type GreeksView = Greeks & { readonly isShowingGreeks?: boolean };

export function greeksView({
  legs,
  auction,
  instruments,
}: Pick<State, 'legs' | 'auction' | 'instruments'>): GreeksView {
  const greeksResult = calculateGreeks(
    legs,
    auction,
    instruments.optionInstruments,
  );
  return formatGreeks(greeksResult);
}

const formatGreeks = (greeks: Greeks) => {
  return {
    delta: parseGreekValue(greeks.delta, GREEKS_PRECISION.delta),
    gamma: parseGreekValue(greeks.gamma, GREEKS_PRECISION.gamma),
    mark_price:
      greeks.mark_price != null && greeks.mark_price !== ''
        ? formatMark(unformatDecimal(greeks.mark_price))
        : '-',
    theta: parseGreekValue(greeks.theta, GREEKS_PRECISION.theta),
    vega: parseGreekValue(greeks.vega, GREEKS_PRECISION.vega),
    isShowingGreeks: isEqual(greeks, EMPTY_GREEKS),
  };
};
